import React from 'react';
import useStyles from './styles';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RequestToUseCustomAddressContent } from './content';
import { Icon, SimpleModal } from '@livable/saas-react-components';
import { RequestToUseCustomAddressContentWithoutCallback } from './withoutCallbackContent';
export default function RequestToUseCustomAddress(_ref) {
  let residencyId = _ref.residencyId,
    callback = _ref.callback,
    data = _ref.data,
    _ref$dumb = _ref.dumb,
    dumb = _ref$dumb === void 0 ? false : _ref$dumb;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const defaultTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    className: classes.trigger,
    'custom-attribute': '363-RequestToUseCustomAddressContent'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Add another address"));
  const editTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    size: "small",
    'custom-attribute': '364-RequestToUseCustomAddressContent'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), t('general.edit'));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: data ? editTrigger : defaultTrigger,
    title: data ? 'Edit address' : t('Add another address'),
    noFooter: true
  }, !dumb && /*#__PURE__*/React.createElement(RequestToUseCustomAddressContent, {
    residencyId: residencyId,
    callback: callback,
    data: data
  }), dumb && /*#__PURE__*/React.createElement(RequestToUseCustomAddressContentWithoutCallback, {
    callback: callback,
    data: data
  }));
}